import React from 'react';
import {Col, ListGroup, Row} from 'react-bootstrap';
import OfferPremiumDescription from './OfferPremiumDescription.jsx';
import OfferPremium from './OfferPremium.jsx';
import {getInstallmentCounts} from '../../../config.js';
import OfferAdditionalDescription from "./OfferAdditionalDescription.jsx";

const InsuranceCompanyOffers = ({
    insuranceCompany,
    product,
}) => {
    const installmentCounts = getInstallmentCounts(product);
    return (<ListGroup.Item key={insuranceCompany.id}>
        <Row>
            <Col className="overflow-hidden">
                <span className="name">{insuranceCompany.shortName}</span>
            </Col>
            {product === 'travel-assistance' &&<Col>
                <OfferAdditionalDescription insuranceCompany={insuranceCompany} installmentsCount={1} />
            </Col>}
            {installmentCounts.map(installmentCount =>
                <Col key={installmentCount} className={'installments text-end installments-' + installmentCount}>
                    <OfferPremium insuranceCompany={insuranceCompany} installmentsCount={installmentCount}
                                  product={product}/>
                </Col>)
            }
        </Row>
        {installmentCounts.length > 1 &&
        <Row>
            <Col md={{ span: 3, offset: 6 }} lg={{ span: 12, offset: 0 }} xl={{ span: 3, offset: 6 }}
                 className="installments text-end installments-2">
                <OfferPremiumDescription insuranceCompany={insuranceCompany} installmentsCount={2} />
            </Col>
            <Col md={3} lg={12} xl={3} className="installments text-end installments-4">
                <OfferPremiumDescription insuranceCompany={insuranceCompany} installmentsCount={4} />
            </Col>
        </Row>
        }
    </ListGroup.Item>);
};

export default InsuranceCompanyOffers;
